import{jsxs as i,jsx as o}from"react/jsx-runtime";import{styled as e}from"styled-components";const t=e.div`
  width: 100%;
  padding: 0.2em 0;
  border: 0px;
  border-bottom: 1px solid #a3a3a3;
  border-radius: 4px 4px 0px 0px;
  margin: 0px;
  background: url(images/dialog_title.png) repeat-x #e3e3e3;
`,n=e.a`
  position: absolute;
  top: 2px;
  width: 1.8em;
  height: 1.8em;
  border-radius: 4px;
  ${i=>`${i.$position}: 2px;`}

  &:hover {
    border: 1px solid #999999;
    background: #dadada;
    top: 1px;
    ${i=>`${i.$position}: 1px`}
  }
`,r=e.span`
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  width: 16px;
  height: 16px;
  margin-left: -8px;
  margin-top: -8px;
  background-image: url(images/ui-icons_256x240.png);
  background-position: ${i=>("left"===i.$position?"-80px":"-48px")+" -192px"};
`,p=e.div`
  margin: 0 2.3em;
  line-height: 1.8em;
  text-align: center;
`;function a(e){return function({date:a,changeYear:d,changeMonth:s,decreaseMonth:g,increaseMonth:x}){return i(t,{children:[o(n,{$position:"left",onClick:g,children:o(r,{$position:"left"})}),o(n,{$position:"right",onClick:x,children:o(r,{$position:"right"})}),o(p,{children:o(e,{date:a,changeMonth:s,changeYear:d})})]})}}export{a as withDatePickerHeader};
